/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths, APIDataProvider, TApiResponse } from '../../../api';
import { ISubscriptionPlan } from '.';

const apiDataProvider = new APIDataProvider();

export const getUserSubscriptionPlans = createAsyncThunk(
  '/subscription-plans/list',
  async (userId?: string) => {
    let path = `${ApiPaths.subscriptionPlans}`;

    if (userId) {
      const queryParams = new URLSearchParams({ userId });
      path += `?${queryParams.toString()}`;
    }

    const response = await apiDataProvider.get<
      TApiResponse<ISubscriptionPlan[]>
    >(path);

    return response.data;
  }
);
